export const stringFilterMethod = (rows, id, filterValue) => {
  if (!filterValue) return rows;
  const value = String(filterValue).toLowerCase();
  return rows.filter(row =>
    String(row.values[id]).toLowerCase().includes(value)
  );
};

export const numberFilterMethod = (rows, id, filterValue) => {
  if (!filterValue.operator) return rows;
  const { operator, operand } = filterValue;

  switch (operator) {
    case '>=': {
      return rows.filter(row => row.values[id] >= operand);
    }
    case '>': {
      return rows.filter(row => row.values[id] > operand);
    }
    case '<=': {
      return rows.filter(row => row.values[id] <= operand);
    }
    case '<': {
      return rows.filter(row => row.values[id] < operand);
    }
    case '==':
    case '=': {
      return rows.filter(row => row.values[id] === operand);
    }
    default: {
      return operand === ''
        ? rows
        : rows.filter(row => `${row.values[id]}`.startsWith(`${operand}`));
    }
  }
};

export const rangeFilterMethod = (rows, id, filterValue) => {
  if (!filterValue) return rows;
  const [left, right] = filterValue;
  return rows.filter(row => {
    return row.values[id] >= left && row.values[id] <= right;
  });
};
